import type { LiteralValues } from '@/utils/typing/literal-values.type';

export const AdvizeoUiElementSize = {
    MICRO: 'micro', // x0.25
    TINY: 'tiny', // x0.5
    SMALL: 'small', // x0.75
    MEDIUM: 'medium', // x1
    LARGE: 'large', // x1.5
    HUGE: 'huge', // x2
    COLOSSAL: 'colossal' // x2.5
} as const;
export type AdvizeoUiElementSize = LiteralValues<typeof AdvizeoUiElementSize>;

export const AdvizeoUiElementImportance = {
    LOW: 'low',
    MEDIUM: 'medium',
    HIGH: 'high'
} as const;
export type AdvizeoUiElementImportance = LiteralValues<typeof AdvizeoUiElementImportance>;
